import { render } from "./Bloqueados.vue?vue&type=template&id=54b976f0"
import script from "./Bloqueados.vue?vue&type=script&lang=js"
export * from "./Bloqueados.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__